import React, { useState } from 'react';
import { AIRecruiterCard } from './AIRecruiterCard';
import { AddAIRecruiterCard } from './AddAIRecruiterCard';
export const AIRecruiters = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  // Sample data for AI recruiters
  const recruiters = [{
    id: 1,
    name: 'Alex',
    avatar: 'A',
    email: 'alex.ai@talentmatch.ai',
    phone: '+1 (555) 123-4567',
    voice: 'American English - Male',
    personality: ['Friendly', 'Professional', 'Detailed'],
    industry: 'Software Engineering',
    stats: {
      scheduled: 48,
      completed: 42,
      minutes: 1260,
      avgTime: 30,
      successRate: 78,
      cost: {
        monthly: 299,
        perInterview: 7.12,
        total: 1495
      }
    }
  }, {
    id: 2,
    name: 'Sarah',
    avatar: 'S',
    email: 'sarah.ai@talentmatch.ai',
    phone: '+1 (555) 987-6543',
    voice: 'British English - Female',
    personality: ['Empathetic', 'Analytical', 'Concise'],
    industry: 'Healthcare',
    stats: {
      scheduled: 36,
      completed: 33,
      minutes: 990,
      avgTime: 27.5,
      successRate: 82,
      cost: {
        monthly: 299,
        perInterview: 9.06,
        total: 1197
      }
    }
  }, {
    id: 3,
    name: 'Michael',
    avatar: 'M',
    email: 'michael.ai@talentmatch.ai',
    phone: '+1 (555) 456-7890',
    voice: 'Australian English - Male',
    personality: ['Enthusiastic', 'Direct', 'Thorough'],
    industry: 'Sales & Marketing',
    stats: {
      scheduled: 54,
      completed: 51,
      minutes: 1530,
      avgTime: 28.3,
      successRate: 75,
      cost: {
        monthly: 299,
        perInterview: 5.86,
        total: 1794
      }
    }
  }];
  return <div data-id="element-128">
      <div className="mb-6" data-id="element-129">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-130">My AI Recruiters</h1>
        <p className="text-gray-600" data-id="element-131">
          Manage your virtual recruiting team and their performance.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-132">
        {recruiters.map(recruiter => <AIRecruiterCard key={recruiter.id} recruiter={recruiter} data-id="element-133" />)}
        <AddAIRecruiterCard onAdd={() => setShowAddModal(true)} data-id="element-134" />
      </div>
      {showAddModal && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-135">
          <div className="bg-white rounded-lg p-6 w-full max-w-2xl" data-id="element-136">
            <div className="flex justify-between items-center mb-4" data-id="element-137">
              <h2 className="text-xl font-bold" data-id="element-138">Create New AI Recruiter</h2>
              <button onClick={() => setShowAddModal(false)} className="text-gray-500 hover:text-gray-700" data-id="element-139">
                &times;
              </button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-140">
              <div data-id="element-141">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-142">
                  Name
                </label>
                <input type="text" className="w-full border border-gray-300 rounded-md px-3 py-2" placeholder="AI Recruiter Name" data-id="element-143" />
              </div>
              <div data-id="element-144">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-145">
                  Email
                </label>
                <input type="email" className="w-full border border-gray-300 rounded-md px-3 py-2" placeholder="name.ai@talentmatch.ai" data-id="element-146" />
              </div>
              <div data-id="element-147">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-148">
                  Phone Number
                </label>
                <input type="tel" className="w-full border border-gray-300 rounded-md px-3 py-2" placeholder="+1 (555) 123-4567" data-id="element-149" />
              </div>
              <div data-id="element-150">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-151">
                  Voice
                </label>
                <select className="w-full border border-gray-300 rounded-md px-3 py-2" data-id="element-152">
                  <option data-id="element-153">American English - Male</option>
                  <option data-id="element-154">American English - Female</option>
                  <option data-id="element-155">British English - Male</option>
                  <option data-id="element-156">British English - Female</option>
                  <option data-id="element-157">Australian English - Male</option>
                  <option data-id="element-158">Australian English - Female</option>
                </select>
              </div>
              <div data-id="element-159">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-160">
                  Industry Specialty
                </label>
                <select className="w-full border border-gray-300 rounded-md px-3 py-2" data-id="element-161">
                  <option data-id="element-162">Software Engineering</option>
                  <option data-id="element-163">Healthcare</option>
                  <option data-id="element-164">Finance</option>
                  <option data-id="element-165">Sales & Marketing</option>
                  <option data-id="element-166">Customer Service</option>
                  <option data-id="element-167">Manufacturing</option>
                </select>
              </div>
              <div data-id="element-168">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-169">
                  Personality Traits
                </label>
                <div className="flex flex-wrap gap-2" data-id="element-170">
                  {['Friendly', 'Professional', 'Analytical', 'Empathetic', 'Direct', 'Thorough'].map(trait => <div key={trait} className="flex items-center" data-id="element-171">
                      <input type="checkbox" id={trait} className="mr-1" data-id="element-172" />
                      <label htmlFor={trait} className="text-sm" data-id="element-173">
                        {trait}
                      </label>
                    </div>)}
                </div>
              </div>
            </div>
            <div className="border-t border-gray-200 pt-4" data-id="element-174">
              <h3 className="font-medium mb-2" data-id="element-175">Pricing Plan</h3>
              <div className="flex gap-4" data-id="element-176">
                <div className="border border-gray-200 rounded-lg p-3 flex-1" data-id="element-177">
                  <div className="font-medium" data-id="element-178">Standard</div>
                  <div className="text-xl font-bold mt-1" data-id="element-179">
                    $299
                    <span className="text-sm font-normal text-gray-500" data-id="element-180">
                      /month
                    </span>
                  </div>
                  <ul className="text-sm mt-2 space-y-1" data-id="element-181">
                    <li data-id="element-182">• Up to 50 interviews/month</li>
                    <li data-id="element-183">• 24/7 availability</li>
                    <li data-id="element-184">• Basic analytics</li>
                  </ul>
                </div>
                <div className="border border-indigo-200 bg-indigo-50 rounded-lg p-3 flex-1" data-id="element-185">
                  <div className="font-medium text-indigo-700" data-id="element-186">Premium</div>
                  <div className="text-xl font-bold mt-1" data-id="element-187">
                    $499
                    <span className="text-sm font-normal text-gray-500" data-id="element-188">
                      /month
                    </span>
                  </div>
                  <ul className="text-sm mt-2 space-y-1" data-id="element-189">
                    <li data-id="element-190">• Unlimited interviews</li>
                    <li data-id="element-191">• Advanced analytics</li>
                    <li data-id="element-192">• Custom voice training</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="mt-6 flex justify-end space-x-3" data-id="element-193">
              <button onClick={() => setShowAddModal(false)} className="px-4 py-2 border border-gray-300 rounded-md text-gray-700" data-id="element-194">
                Cancel
              </button>
              <button className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700" data-id="element-195">
                Create AI Recruiter
              </button>
            </div>
          </div>
        </div>}
    </div>;
};